<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Account Ledger"
              bc1="App"
              bc2="Ledger"
              bc3="List"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <div class=" d-flex justify-content-end" v-if="!isPartnerLedger">
            <div class="col-md-4" >
              <SelectOptions
                  label=""
                  selectAppend="transaction type"
                  labelValue="name"
                  :modelValue.sync="selectedType"
                  url="v1/transaction-types"
              />
            </div>
          </div>


          <LoadMoreCommonTable
              url="v1/get-ledger"
              :filteredData="filteredData"
              :tableHeaderValues="tableHeaderValues"
              :actions="[]"
              :deleteActions="[]"
              :mutedData="[]"
              :storageKey="storageKey"
              :externalTotalRecord="externalTotalRecord"
              @perPageFilterChanged="perPageFilterChanged"
              :loadMore="true"
              :alterResponseData="alter"
              :showPerPage="true"
              @getFullResponse="getFullResponse"


          >
            <template  v-slot:additionalFilter>
              <div class="col-12 d-flex mb-1  justify-content-center" v-if="filterLoader && !isPartnerLedger">
                <div class="spinner-border text-primary"></div>
              </div>
              <div class="row  ml-2" v-show="!filterLoader && !isPartnerLedger">
                <div class="col-md-6 col-sm-12">
                  <InfiniteSelect
                      api-url="v1/get-store"
                      ref="storeInfiniteSelect"
                      :request-params="requestParams"
                      :formatter="customStoreNameForMultiselect"
                      key-field="id"
                      @selectedFullObj="handleStoreSelected"
                      placeholder-text="Select a store..."
                  />
                </div>
                <div class="col-md-6 col-sm-12">
                  <InfiniteSelect
                      api-url="v1/get-channel"
                      ref="channelInfiniteSelect"
                      :request-params="requestParams"
                      :formatter="(obj) => obj.name + '/' + obj.code"
                      key-field="id"
                      @selectedFullObj="handleChannelSelected"
                      placeholder-text="Select a channel..."
                  />
                </div>
              </div>
              <div class="row  ml-2 mt-1" v-show="!filterLoader && !isPartnerLedger">
                <div class="col-md-6 col-sm-12">
                  <date-picker
                      v-model="fromDate"
                      :disabledDate="disableFutureDates"
                      valueType="format"
                      :lang="lang"
                      name="fromDate"
                      placeholder="choose start date"
                      class="w-100"
                  ></date-picker>
                </div>
                <div class="col-md-6 col-sm-12">
                  <date-picker
                      v-model="toDate"
                      :disabledDate="disableFutureDates"
                      valueType="format"
                      :lang="lang"
                      name="toDate"
                      placeholder="choose end date"
                      class="w-100"
                  ></date-picker>
                </div>
              </div>
              <div class="row mt-1  ml-2 mb-2" v-show="!filterLoader && !isPartnerLedger">
                <div class="col-sm-6">
                  <button type="button" class="btn btn-primary btn-sm" @click="onSubmitFilters" >Search</button>
                  <button type="button" class="ml-1 btn btn-dark btn-sm "  @click="clear">Clear</button>
                </div>
                <div class="col-md-6 col-sm-12 d-flex justify-content-end">
                  <button  type="button" class="btn-sm btn btn-gradient-success" @click="exportExcel">
                    <feather type="file-text"></feather>
                    Export Excel
                  </button>
                </div>
              </div>
            </template>
          </LoadMoreCommonTable>
        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import DatePicker from "vue2-datepicker";
import InfiniteSelect from "@/components/common/InfiniteSelect.vue";
export default {
  components:{InfiniteSelect, DatePicker},
  computed: {
    isPartnerLedger() {
      // opened from the partner details page: plain ledger without filters or export
      return this.$route.query.from == 'partner'
    }
  },
  mounted() {
    localStorage.setItem("url", "v1/get-ledger");
    this.checkDataInStore('v1/get-ledger')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }

    this.requestParams = {
      userId:this.$route.params.uuid
    }
  },
  data() {
    return {
      alter:{
        alter: (value) => {
          if(value){
            if(value.data){
              let temp = []
              value.data.forEach((eachArrayItem,index)=>{

                if(typeof(value.fullResponse.closingBalance) != 'undefined' && index == 0 && value.pagination.currentPage == 1){
                  this.orignalGivenClosingBalance = value.fullResponse.closingBalance
                  this.lastClosingBalance = this.orignalGivenClosingBalance

                  eachArrayItem.closing_balance = this.lastClosingBalance

                  if(parseFloat(eachArrayItem.credit_amount) != parseFloat(0)){
                    //credit
                    this.lastClosingBalance = parseFloat(this.lastClosingBalance) -  parseFloat(eachArrayItem.credit_amount)

                  }else{
                    this.lastClosingBalance = parseFloat(this.lastClosingBalance) +  parseFloat(eachArrayItem.debit_amount)
                  }

                }else{
                  eachArrayItem.closing_balance = this.lastClosingBalance

                  if(parseFloat(eachArrayItem.credit_amount) != parseFloat(0)){
                    //credit
                    this.lastClosingBalance = parseFloat(this.lastClosingBalance) -  parseFloat(eachArrayItem.credit_amount)

                  }else{
                    this.lastClosingBalance = parseFloat(this.lastClosingBalance) +  parseFloat(eachArrayItem.debit_amount)
                  }


                }


                temp.push(eachArrayItem)
              })
              value.data = temp
            }
          }

          return value
        }
      },
      filterLoader:false,
      orignalGivenClosingBalance:0,
      lastClosingBalance:0,
      fromDate: null,
      toDate: null,
      channelLoader:false,
      channelData:[],
      selectedChannel:null,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      externalTotalRecord: "",
      storageKey: "account-ledger",
      accountId: null,
      selectdValet: null,
      filteredData:{userAccountId : parseInt(this.$route.params.id) },
      valetData: [],
      tableHeaderValues: [
        {
          title: 'Transaction ID',
          valueKey: 'transaction.uuid',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = `<span class="text-primary" style="cursor: pointer" title="Click For Details">${value}</span>`


            return html


          },
        },
        {
          title: 'Debit Amount',
          valueKey: 'debit_amount',
          html: true,
          alter:  (value) => {
            var html = ''
            html = `<span style="font-size: larger" class=" font-weight-bolder text-danger">${this.modifyAmount(parseFloat(value / 100).toFixed(this.amountDecimalPlaces))}</span>`
            if ((value / 100) == 0) {
              html = `<span style="font-size: larger" class=" font-weight-bolder text-danger">-</span>`
            }

            return html

          }
        },
        {
          title: 'Credit Amount',
          valueKey: 'credit_amount',
          html: true,
          alter:  (value) => {
            var html = ''
            html = `<span style="font-size: larger" class=" font-weight-bolder text-success">${this.modifyAmount(parseFloat(value / 100).toFixed(this.amountDecimalPlaces))}</span>`
            if ((value / 100) == 0) {
              html = `<span style="font-size: larger" class=" font-weight-bolder text-success">-</span>`
            }
            return html

          }
        },
        {
          title: 'Closing Balance',
          valueKey: 'closing_balance',
          alter:  (value) => {
            return this.modifyAmount(parseFloat(value/100).toFixed(8),8)
          }
        },
        {
          title: 'Currency',
          valueKey: 'transaction.currency.code',
          html: true,
          alter: function (value) {
            var html = ''
            html = ` <a href="javascript:void()" class="badge badge-glow badge-warning">${value}</a>`

            return html


          }
        },
        {
          title: 'Transaction Type',
          valueKey: 'transaction_type.name',
          html: true,
          alter: function (value) {
            var html = ''
            html = ` <span class="badge light badge-primary">
														${value}
													</span>`

            return html


          }
        },
        {
          title: 'Transaction Time/Date',
          titleHtml: `<br> <span class="text-warning font-weight-bolder">
														(Showing In GMT)
													</span>`,
          valueKey: 'created_at',
          alter: (value) => {
            // return this.customFormatDateTime(value)
            return new Date(value).toISOString().slice(0, 16).replace('T', ' ')
          }
        },
      ],
      actions: [],
      selectedType: null,
      requestParams: {},
      selectedStore: null,
    }
  },
  methods: {
    customStoreNameForMultiselect ({ name,code }) {
      return `${name}/${code}`
    },
    handleStoreSelected(item) {
      let {id} = {...item}
      this.selectedStore = id
    },
    handleChannelSelected(item) {
      let {id} = {...item}
      this.selectedChannel = id
    },
    getFullResponse(response) {
      this.filterLoader = false
    },
    perPageFilterChanged(){
      this.lastClosingBalance = this.orignalGivenClosingBalance
    },
    exportExcel(){

      if(!this.toDate || !this.fromDate){
        this.$toast.error('Date Filters Are Required To Generate Excel', {
          position: "top-center",
          timeout: 2000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          maxToasts: 1
        })

        return
      }


      let requestData = {
        exportAs: 'excel',
        reportType: 'transaction_ledger',
        userAccountId : parseInt(this.$route.params.id)
      }

      if(this.toDate){
        requestData.toDate = this.toDate
      }
      if(this.fromDate){
        requestData.fromDate = this.fromDate
      }

      if(this.selectedChannel){
        requestData.channelId = this.selectedChannel
      }



      this.downloadReport(requestData)
    },
    onSubmitFilters() {
      this.filterLoader = true
      let filterData = {userAccountId : parseInt(this.$route.params.id)}

      if(this.selectedType){
        filterData.transactionTypeId = this.selectedType.id
      }
      if(this.selectedChannel){
        filterData.channelId = this.selectedChannel
      }

      if (this.selectedStore) {
        filterData.storeId = this.selectedStore
      }

      if(this.toDate){
        filterData.toDate = this.toDate
      }
      if(this.fromDate){
        filterData.fromDate = this.fromDate
      }



      this.filteredData = filterData




    },
    clear(){
      this.filterLoader = true
      this.toDate = null
      this.fromDate = null
      this.selectedChannel = null
      this.selectedStore = null
      this.$refs.channelInfiniteSelect.clearSearch();
      this.$refs.storeInfiniteSelect.clearSearch();
      let filterData = {userAccountId : parseInt(this.$route.params.id)}
      if(this.selectedType){
        filterData.transactionTypeId = this.selectedType.id
      }
      this.filteredData = filterData

    },
    getChannelData() {
      this.channelLoader = true
      this.makeRequest("post", "v1/get-channel", { status:'all',userId:this.$route.params.uuid }, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.channelData = responseData;
                }
                else{
                  this.channelData = []
                }

              }
            }
            this.channelLoader = false
          }
      );
    },

  },
  watch:{
    selectedType(val){
      if(val){
        this.filteredData = {
          userAccountId : parseInt(this.$route.params.id),
          transactionTypeId: val.id
        }
      }else{
        this.filteredData = {userAccountId : parseInt(this.$route.params.id) }
      }

    }
  }

}
</script>

